/**
 * ISO 639-1 Language Code
 *
 * lower case
 */
export var Region;
(function (Region) {
    Region["jp"] = "jp";
    Region["th"] = "th";
    Region["my"] = "my";
    Region["id"] = "id";
    Region["ph"] = "ph";
    Region["vn"] = "vn";
    Region["us"] = "us";
    Region["gb"] = "gb";
    Region["sg"] = "sg";
    Region["au"] = "au";
    Region["ca"] = "ca";
    Region["nz"] = "nz";
})(Region || (Region = {}));
export const RegionDisplayMap = {
    [Region.jp]: '日本',
    [Region.th]: 'ไทย',
    [Region.my]: 'Malaysia',
    [Region.id]: 'Indonesia',
    [Region.vn]: 'Việt Nam',
    [Region.us]: 'US',
    [Region.gb]: 'UK',
    [Region.sg]: 'Singapore',
    [Region.ph]: 'Philippines',
    [Region.au]: 'Australia',
    [Region.ca]: 'Canada',
    [Region.nz]: 'New Zealand',
};
export var DeploymentVGeo;
(function (DeploymentVGeo) {
    DeploymentVGeo["US"] = "US";
    DeploymentVGeo["EU"] = "EU";
    DeploymentVGeo["ROW"] = "ROW";
})(DeploymentVGeo || (DeploymentVGeo = {}));
export var DeploymentVRegion;
(function (DeploymentVRegion) {
    DeploymentVRegion["US_TTP"] = "US-TTP";
    DeploymentVRegion["US_TTP2"] = "US-TTP2";
    DeploymentVRegion["US_EAST"] = "US-East";
    DeploymentVRegion["US_EASTRED"] = "US-EastRed";
    DeploymentVRegion["SG_CENTRAL"] = "Singapore-Central";
})(DeploymentVRegion || (DeploymentVRegion = {}));
export var DeploymentVDC;
(function (DeploymentVDC) {
    DeploymentVDC["USEAST5"] = "useast5";
    DeploymentVDC["USEAST8"] = "useast8";
    DeploymentVDC["MALIVA"] = "maliva";
    DeploymentVDC["SG1"] = "sg1";
    DeploymentVDC["MY"] = "my";
    DeploymentVDC["MY2"] = "my2";
    DeploymentVDC["USEAST2B"] = "useast2b";
})(DeploymentVDC || (DeploymentVDC = {}));
export var SCMBuildRegion;
(function (SCMBuildRegion) {
    SCMBuildRegion["CN"] = "cn";
    SCMBuildRegion["OCI"] = "oci";
})(SCMBuildRegion || (SCMBuildRegion = {}));
export var ClientBuildRegion;
(function (ClientBuildRegion) {
    ClientBuildRegion["VA"] = "va";
    ClientBuildRegion["SG"] = "sg";
    ClientBuildRegion["OCI"] = "oci";
    ClientBuildRegion["EU"] = "eu";
})(ClientBuildRegion || (ClientBuildRegion = {}));
/**
 * @deprecated not compatible with TTP
 */
export var IDCRegion;
(function (IDCRegion) {
    IDCRegion["VA"] = "va";
    IDCRegion["SG"] = "sg";
})(IDCRegion || (IDCRegion = {}));
/**
 * @deprecated not compatible with TTP
 */
export const getRegionIDC = (region) => {
    return [Region.jp, Region.us, Region.gb].includes(region) ? IDCRegion.VA : IDCRegion.SG;
};
export const getDestinationVRegionBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVRegion.US_TTP;
        case Region.gb:
            return DeploymentVRegion.US_EASTRED;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.au:
        case Region.nz:
            return DeploymentVRegion.SG_CENTRAL;
        case Region.jp:
        case Region.ca:
        default:
            return DeploymentVRegion.US_EAST;
    }
};
export const getDestinationVDCBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVDC.USEAST5;
        case Region.gb:
            return DeploymentVDC.USEAST2B;
        // temporarily returned to the Maliva
        case Region.jp:
        case Region.ca:
            return DeploymentVDC.MALIVA;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.au:
        case Region.nz:
        default:
            return DeploymentVDC.SG1;
    }
};
export const getDestinationVGeoBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVGeo.US;
        case Region.gb:
            return DeploymentVGeo.EU;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.jp:
        case Region.ca:
        case Region.au:
        case Region.nz:
        default:
            return DeploymentVGeo.ROW;
    }
};
